<template>
    <div>

        <vue-headful title="Employee Disciplinary Actions :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/employees/disciplinary-actions`">
                        <i class="fa fa-gavel"></i> Disciplinary Actions
                    </router-link>
                </li>
                <template v-if="id">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/employees/disciplinary-actions/view/${id}`">
                            <template v-if="action.disc_violation_id">{{ action.violation_name }}</template>
                            <template v-else>{{ action.other_violation_name }}</template>
                             on {{ action.disc_action_date | moment("MM/DD/YYYY") }} by {{ action.employee_first_name }} {{ action.employee_last_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active"><i class="fa fa-edit"></i> Edit</li>
                </template>
                <template v-else>
                    <li class="breadcrumb-item active">Create</li>
                </template>
                <li class="ml-3">
                    <button type="button" class="btn btn-sm btn-success" v-on:click="saveAction()" :disabled="saving" v-if="!loading">
                        <span v-if="saving">Saving...</span>
                        <span v-else>
                            {{ id ? 'Update' : 'Create' }}
                        </span>
                        Disciplinary Action
                    </button>
                </li>
            </ol>
        </h4>

        <div>
            <div class="row">
                <div class="col-xl-8 col-lg-12">
                    <div class="card">
                        <div class="card-body" v-if="loading">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
                        </div>
                        <div class="card-body" v-else>
                            <div class="form-group row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.supervisor_id}">Supervisor:</label>
                                <div class="col-sm-8">
                                    <div v-if="this.$root.hasPermission('employees.disciplinary.manage')">
                                        <user-select :selectedValues="userSelectValues" @vuselected="onUserSelectUpdate" :hasError="errors.supervisor_id ? true : false"></user-select>
                                        <span v-if="errors.supervisor_id" class="text-danger">
                                            <span v-for="error in errors.supervisor_id">{{ error }}</span>
                                        </span>
                                    </div>
                                    <div v-else>
                                        {{ this.$store.state.user.first_name }} {{ this.$store.state.user.last_name }}
                                    </div>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.employee_id }" class="row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.employee_id }">
                                    Employee:
                                    <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">

                                    <employee-select ref="employeeSelector" :selectedValues="EmployeeValues" @vselected="onEmployeeSelect" :hasError="errors.employee_id ? true : false"></employee-select>

                                    <span v-if="errors.employee_id" class="text-danger">
                                        <span v-for="error in errors.employee_id">{{ error }}</span>
                                    </span>

                                    <div v-if="show_signature_reset_alert" class="alert alert-warning mt-1">
                                        <strong>Note:</strong> Changing the Employee will clear the Employee signature fields. The new employee will be able to sign the disciplinary action
                                    </div>
                                </div>
                            </div>

                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.jobsite_id }" class="row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.jobsite_id}">
                                    Jobsite:
                                    <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8">
                                    <jobsite-select :selectedValues="selectedJobsite" v-on:vselected="onJobSiteSelectUpdate" :hasError="errors.jobsite_id ? true : false"></jobsite-select>
                                    <span v-if="errors.jobsite_id" class="text-danger">
                                        <span v-for="error in errors.jobsite_id">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <hr/>

                            <div class="form-group row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.disc_action_date }">
                                    Date of Violation:
                                    <i class="fa fa-asterisk text-danger" v-if="!action.disc_action_date"></i>
                                </label>
                                <div class="col-sm-8">

                                    <input type="date" v-model="action.disc_action_date" :class="{'form-control': true, 'is-invalid': errors.disc_action_date}" />

                                    <span v-if="errors.disc_action_date" class="text-danger">
                                        <span v-for="error in errors.disc_action_date">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.disc_violation_id}">
                                    Violation:
                                    <i class="fa fa-asterisk text-danger" v-show="!other_violation"></i>
                                </label>
                                <div class="col-sm-8">
                                    <select v-model="action.disc_violation_id" :class="{'form-control': true, 'is-invalid': errors.disc_violation_id}" :disabled="other_violation">
                                        <option :value="null">-- Select a Violation Or Check Other --</option>
                                        <option v-for="(viol, key) in violations" v-bind:value="viol.disc_violation_id">
                                            {{ viol.violation_name }}
                                        </option>
                                    </select>
                                    <div v-if="errors.disc_violation_id" class="text-danger">
                                        <span v-for="error in errors.disc_violation_id">{{ error }}</span>
                                    </div>
                                    <label class="mt-2">
                                        <input type="checkbox" v-model="other_violation" value="true" />
                                        Other Violation
                                    </label>
                                </div>
                            </div>
                            <template v-if="other_violation == true">
                                <hr/>
                                <div class="form-group row mb-2">
                                    <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.other_violation_name}">
                                        Other Violation Name:
                                        <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-sm-8 pt-1">
                                        <input type="text" v-model="action.other_violation_name" :class="{'form-control': true, 'is-invalid': errors.other_violation_name}" placeholder="Other Violation Name" />
                                        <span v-if="errors.other_violation_name" class="text-danger">
                                            <span v-for="error in errors.other_violation_name">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row mb-2">
                                    <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.other_penalty_name}">
                                        Other Penalty Name:
                                        <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-sm-8 pt-1">
                                        <input type="text" v-model="action.other_penalty_name" :class="{'form-control': true, 'is-invalid': errors.other_penalty_name}" placeholder="Other Penalty Name" />
                                        <span v-if="errors.other_penalty_name" class="text-danger">
                                            <span v-for="error in errors.other_penalty_name">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row mb-2">
                                    <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.other_bonus_disqual_time}">
                                        Safety Bonus Disqualification:
                                        <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <div class="col-sm-8 pt-1">
                                        <input type="text" v-model="action.other_bonus_disqual_time" :class="{'form-control': true, 'is-invalid': errors.other_bonus_disqual_time}" placeholder="Other Disqualification Time" />
                                        <span v-if="errors.other_bonus_disqual_time" class="text-danger">
                                            <span v-for="error in errors.other_bonus_disqual_time">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <hr/>
                            </template>
                            <div class="form-group row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.warning_type}">
                                    Warning: <i class="fa fa-asterisk text-danger"></i>
                                </label>
                                <div class="col-sm-8 pt-1">
                                    <label v-for="(value, key) in warningTypes" class="mr-3">
                                        <input type="radio" name="warning_type" v-model="action.warning_type" :value="value" />
                                        {{ value }}
                                    </label>
                                    <span v-if="errors.warning_type" class="text-danger">
                                        <span v-for="error in errors.warning_type">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.was_discharged}">Discharged:</label>
                                <div class="col-sm-8 pt-1">
                                    <b-form-checkbox v-model="action.was_discharged" value="1" plain></b-form-checkbox>
                                    <span v-if="errors.was_discharged" class="text-danger">
                                        <span v-for="error in errors.was_discharged">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.days_suspension}">Suspension:</label>
                                <div class="col-sm-8">
                                    <div class="input-group">
                                        <input type="text" v-model="action.days_suspension" :class="{'form-control': true, 'is-invalid': errors.days_suspension}" placeholder="Enter the Number of Days Suspension. Decimals Accepted for half days." />
                                        <div class="input-group-append">
                                            <span class="input-group-text">Days</span>
                                        </div>
                                    </div>
                                    <span v-if="errors.days_suspension" class="text-danger">
                                        <span v-for="error in errors.days_suspension">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row mb-2">
                                <label :class="{ 'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.files}">File(s):</label>
                                <div class="col-sm-8">
                                    <b-form-file v-model="files" class="mt-3" multiple placeholder="Attach Written Statements, Lessons Learned, or Other Files"></b-form-file>

                                    <span v-if="errors.files" class="text-danger mt-2">
                                        <span v-for="error in errors.files">{{ error }}</span>
                                    </span>

                                    <div class="mt-2">
                                        <file-list :files="existingFiles" :displayType="'list'"></file-list>
                                    </div>
                                </div>
                            </div>
                            <hr/>

                            <div class="form-group row mb-4">
                                <div class="col-sm-10 offset-sm-1">
                                    <label :class="{ 'col-form-label text-sm-right': true, 'text-danger': errors.violation_detail}">
                                        Explanation of Violation: <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <textarea v-model="action.violation_detail" :class="{'form-control': true, 'is-invalid': errors.violation_detail}" placeholder="Enter an Explanation of the Current Violation" style="min-height: 100px;"></textarea>
                                    <span v-if="errors.violation_detail" class="text-danger">
                                        <span v-for="error in errors.violation_detail">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col-sm-10 offset-sm-1">
                                    <label :class="{ 'col-form-label text-sm-right': true, 'text-danger': errors.reason_detail}">What Reason(s) did the employee give for their action?</label>
                                    <textarea v-model="action.reason_detail" :class="{'form-control': true, 'is-invalid': errors.reason_detail}" placeholder="Enter the Reason or Reasons the employee gave for their actions." style="min-height: 100px;"></textarea>
                                    <span v-if="errors.reason_detail" class="text-danger">
                                        <span v-for="error in errors.reason_detail">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card mt-3" v-if="!loading && !action.disc_action_id">
                        <div class="card-body">
                            <p>Sign and Date will be available after creation.</p>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">
                    <disciplinary-previous ref="empPreviousActions" v-bind:disc_action_id="id" />
                    <div class="card mt-3" v-if="!loading">
                        <div class="card-header">Safety Incentive Program</div>
                        <div class="card-body">
                            <b-table bordered striped hover condensed :items="violations" :fields="incentiveFields"></b-table>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>

            <button type="button" class="btn btn-success" v-on:click="saveAction()" :disabled="saving" v-if="!loading">
                <span v-if="saving">Saving...</span>
                <span v-else>
                    {{ id ? 'Update' : 'Create' }}
                </span>
                Disciplinary Action
            </button>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {

        data: function() {
            return {
                loading: true,
                saving: false,
                show_signature_reset_alert: false,
                id: this.$route.params.id,
                action: {},
                violations: [],
                warningTypes: {},
                errors: {},
                files: [],
                existingFiles: [],
                other_violation: false,
                previous_actions_loading: false,
                previous_action_days: 180,
                previous_actions: [],
                incentiveFields: [
                    {key: 'violation_name', label: 'Violation'},
                    {key: 'penalty_name', label: 'Penalty'},
                    {key: 'bonus_disqual_time', label: 'Safety Disqual.'},
                ],
            }
        },

        computed: {
            violationOptions(){
                //Options
                var options = {};

                //Send it
                return options;
            },

            warningTypeOptions(){
                //Options
                var options = {};

                for(var i in this.warningTypes)
                {
                    options[this.warningTypes[i]] = this.warningTypes[i];
                }

                //Send it
                return options;
            },

            //User Setter
            userSelectValues(){
                //Check for null
                if(!this.action.supervisor_id || this.action.supervisor_id == null)
                {
                    this.action.supervisor_id = this.$store.state.user.user_id;
                    return { supervisor_id: this.$store.state.user.user_id, FirstName: this.$store.state.user.first_name, LastName: this.$store.state.user.last_name };
                }

                //Send it
                return { supervisor_id: this.action.supervisor_id, FirstName: this.action.supervisor_first_name, LastName: this.action.supervisor_last_name};
            },

            EmployeeValues(){
                //check for null
                if(!this.action.employee_id)
                {
                    return null;
                }

                return {EmployeeId: this.action.employee_id, FirstName: this.action.employee_first_name, LastName: this.action.employee_last_name, EmployeeNumber: this.action.employee_number};
            },

            selectedJobsite(){
                //check for null
                if(!this.action.jobsite_id || this.action.jobsite_id == null)
                {
                    //Check the store
                    if(this.$store.state.user.jobsite)
                    {
                        //Set the jobsite
                        var jobsite = this.$store.state.user.jobsite;

                        //Set the HSE jobsite
                        this.action.jobsite_id = jobsite.JobsiteId;

                        //Send it
                        return {JobsiteId: jobsite.JobsiteId, JobsiteNumber: jobsite.JobsiteNumber, JobsiteName: jobsite.JobsiteName};
                    }

                    //Send it
                    return null;
                }

                //Send it
                return {JobsiteId: this.action.jobsite_id, JobsiteNumber: this.action.JobsiteNumber, JobsiteName: this.action.JobsiteName};
            },
        },

        watch: {
            'action.employee_id'(newVal, oldVal){
                //IF someone is editing the action and changing the employee, we need to show the alert that the action
                //signature and signature timestamp will be erased.
                console.log([newVal, oldVal]);
                if(newVal !== null && oldVal !== null && typeof oldVal != 'undefined' && newVal !== oldVal)
                {
                    //Show the alert
                    this.show_signature_reset_alert = true;
                }
            },

            'other_violation'(newVal, oldVal){
                //If true, make sure the Violation type is reset
                if(newVal === true)
                {
                    this.action.disc_violation_id = null;
                }
            }
        },

        methods: {
            //Get the Action
            getAction(){
                //Send it
                this.$http.get('/employees/disciplinary-actions/edit' + (this.id ? '/'+this.id : ''))
                    .then(res => {
                        //Set the resources
                        this.action = res.data.action;
                        this.violations = res.data.violations;
                        this.warningTypes = res.data.warningTypes;
                        this.existingFiles = res.data.files;

                        //Set some data
                        if(this.id)
                        {
                            this.action = res.data.action;
                            this.other_violation = this.action.disc_violation_id ? false : true;

                            //Set the previous
                            this.$refs.empPreviousActions.setEmployeeId(this.action.employee_id);
                        }
                        else
                        {
                            this.action.disc_violation_id = null;
                        }
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Done loading
                        this.loading = false;
                    });
            },

            saveAction(){
                //Done loading
                this.saving = true;

                //Setter
                this.action.other_violation = this.other_violation;

                //Send it
                this.$http.postWithFiles('/employees/disciplinary-actions/edit' + (this.id ? '/' + this.id : ''), this.action, this.files)
                    .then(res => {
                        //Alert
                        this.$toastr.success('Disciplinary Action Saved');

                        //Return to main list?
                        this.$router.push('/employees/disciplinary-actions/view/' + res.data.disc_action_id);
                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Save Disciplinary Action');
                        }
                    })
                    .then(() => {
                        //Done loading
                        this.saving = false;
                    });
            },

            onUserSelectUpdate (user){
                //Check for null
                if(user == null)
                {
                    this.action.supervisor_id = null
                    return;
                }

                //Set it
                this.action.supervisor_id = user.UserId;
            },

            onEmployeeSelect(employee){
                //Setter
                this.action.employee_id = employee.EmployeeId;
                this.action.employee_number = employee.EmployeeNumber;

                //Set the previous
                this.$refs.empPreviousActions.setEmployeeId(this.action.employee_id);
            },

            onJobSiteSelectUpdate (jobsite) {
              //Check for null
                if(jobsite == null)
                {
                    //Stop
                    this.action.jobsite_id = null;
                    return;
                }

                //Send the value
                this.action.jobsite_id = jobsite.JobsiteId;
                //this.action.JobsiteName = jobsite.JobsiteName;
                //this.action.JobsiteNumber = jobsite.JobsiteNumber;
            },
        },

        mounted() {
            //Get the HSE
            this.getAction();
        }
    }
</script>
